(function(){
     'use strict';

     angular
        .module('app')
        .factory('FiltrosService', FiltrosService);

    FiltrosService.$inject = ['$http'];

    function FiltrosService($http){


        var service= {
            saveFiltro: saveFiltro,
            getFiltros:getFiltros,
            borrarFiltro:borrarFiltro
        };

        return service;

        function saveFiltro(type,id,vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            type = JSON.stringify(type, function (key, val) {
                     if (key == '$$hashKey') {
                       return undefined;
                     }
                     return val;
                });
            var data = $.param({
                id:id,
                role_id: vm.role_id,
                filtro: type 
            });
            $http.post('/backend/altcrm/filtrostype/savefiltro', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function borrarFiltro(filtro,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                filtro:filtro
            });
            $http.post('/backend/altcrm/filtrostype/borrarfiltro', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getFiltros(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                },ignoreLoadingBar: true
            }

            var data = $.param({
                ignoreLoadingBar: true, 
                type:vm.type,
                user_id:vm.user_id,
                role_id:vm.role_id
            });
            $http.post('/backend/altcrm/filtrostype/getfiltros', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
    }
})();